import React,{useState,useEffect} from 'react';
import TitleHeader from 'components/presenters/header/TitleHeader';
import FriendList from 'components/containers/friend/FriendList';
import serverController from 'server/serverController'; 
import qs from 'qs';
import styled from 'styled-components';
export default function FriendListLayout() {
	//친구 리스트 불러오기
	const [friendlist , setFriendlist] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isEnd, setIsEnd] = useState(false);
	const [lastPosNo, setLastPosNo] = useState(null);

	const loadFriendList = () => {
		if(!isLoading && !isEnd)
		{
			const limitVal = 20;
			setIsLoading(true);
			let form = {};
			form['limit'] = limitVal;
			form['last_pos_no'] = lastPosNo;
			let queryString = qs.stringify(form);
			serverController.getServerData(`friends?${queryString}`,(res)=>{
				try
				{
					setIsLoading(false);
					if(res.success !== 1) {
						alert("예기치 못한 오류가 발생하였습니다.");
						return;
					}
					let jsonData = res.data;
					let receivedList = jsonData.friends;
					if(receivedList.length < limitVal)
					{
						setIsEnd(true);
					}
					setLastPosNo(receivedList[receivedList.length - 1]['no']);
					setFriendlist([...friendlist,...receivedList]);
				}
				catch(err)
				{
					setIsLoading(false);
					console.log(err);
				}
				
			});
		} 
	}

	useEffect(() => {
		loadFriendList();
	},[]);


	// 친구신청 삭제
	const [currentPostIndex , setCurrentPostIndex] = useState(0);
	const deleteCallBack  = (res) =>{
		try
		{
			if(res.success !== 1){
				alert("예기치 못한 오류가 발생하였습니다.");
				return;
			} else {
				window.location.reload();
			}
		} catch(err) {
			console.log(err);
		}
	}
	const deleteSubmit=()=> {
		let data = {};
		serverController.updateFileDeleteFetchController(`friends/users/${currentPostIndex}`,JSON.stringify(data),deleteCallBack);
	}

	const handleScroll = (e)=>{
		const bottom = e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight;
		if (bottom) {
			loadFriendList();
		}
	}

	return (
		<ListSection >
			<Header>
				<TitleHeader title={"친구"}  borderbottom={'calc(100vw*(1/375)) solid #d5d5d5'} />
			</Header>
			<FriendListWrapper onScroll={handleScroll}>
				<FriendList 
					isEnd={isEnd}
					display={"none"} 
					friendlist={friendlist}
					deleteSubmit={deleteSubmit}
					setCurrentPostIndex={setCurrentPostIndex}
				/>
			</FriendListWrapper>
		</ListSection>
		);
}
const ListSection = styled.div`
	height: 100vh;
	display: flex;
	flex-direction:column;
`

const Header = styled.div`
	min-height: calc(100vw*(51/375));
	height: calc(100vw*(51/375));
`
const FriendListWrapper = styled.div`
	overflow-y: scroll;
	flex: 1 1 auto;
`